import BackupIcon from "@mui/icons-material/Backup";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function PdfUploader({ file, setFile }) {
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (!file) {
      setPreviewUrl("");
      return;
    }

    const url = URL.createObjectURL(file);
    setPreviewUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [file]);

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleUpload = async (event) => {
    const selectedFile = event.target.files[0];

    if (!selectedFile) return;

    if (selectedFile.type !== "application/pdf") {
      Swal.fire({
        icon: "warning",
        title: "Invalid File",
        text: "Only PDF files are allowed.",
        customClass: {
          container: 'my-swal'
        },
      });
      return;
    }

    if (selectedFile.size / 1024 / 1024 > 1) {
      Swal.fire({
        icon: "warning",
        title: "Maximum file size is 1 MB",
        customClass: {
          container: 'my-swal'
        },
      });
      return;
    }

    const base64 = await fileToBase64(selectedFile);

    // localStorage.setItem("forwardingLetter", base64);
    // localStorage.setItem("forwardingLetterName", selectedFile.name);

    setFile(selectedFile);
  };

//   useEffect(() => {
//     const saved = localStorage.getItem("forwardingLetter");
//     const name = localStorage.getItem("forwardingLetterName");

//     if (saved && !file) {
//       const arr = saved.split(",");
//       const mime = arr[0].match(/:(.*?);/)[1];
//       const bstr = atob(arr[1]);
//       let n = bstr.length;
//       const u8arr = new Uint8Array(n);

//       while (n--) {
//         u8arr[n] = bstr.charCodeAt(n);
//       }

//       const restored = new File([u8arr], name, {
//         type: mime,
//       });

//       setFile(restored);
//     }
//   }, []);

  const removeFile = () => {
    Swal.fire({
      title: "Remove PDF?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
          container: 'my-swal'
        },
    }).then((result) => {
      if (result.isConfirmed) {
        // localStorage.removeItem("forwardingLetter");
        // localStorage.removeItem("forwardingLetterName");
        setFile(null);
      }
    });
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              color: "#1565c0",
              fontWeight: 600,
            }}
          >
            Forwarding Letter
          </Typography>

          <Typography color="text.secondary">
            Upload PDF (Maximum Size: 1 MB)
          </Typography>
        </Grid>

        <Grid item xs={12} md={7}>
          <Card
            variant="outlined"
            sx={{
              borderStyle: "dashed",
              borderWidth: 2,
              borderColor: "#1976d2",
            }}
          >
            <CardContent
              sx={{
                textAlign: "center",
                py: 6,
              }}
            >
              <PictureAsPdfIcon
                sx={{
                  fontSize: 70,
                  color: "#d32f2f",
                }}
              />

              <Typography mt={2}>
                Click below to upload your forwarding letter.
              </Typography>

              <Button
                variant="contained"
                component="label"
                startIcon={<BackupIcon />}
                sx={{
                  mt: 3,
                }}
              >
                Upload PDF

                <input
                  hidden
                  accept="application/pdf"
                  type="file"
                  onChange={handleUpload}
                />
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={5}>
          <Card
            variant="outlined"
            sx={{
              height: "100%",
            }}
          >
            <CardContent>
              <Typography variant="h6">
                Uploaded File
              </Typography>

              {file ? (
                <>
                  <Typography mt={2}>
                    <strong>Name:</strong> {file.name}
                  </Typography>

                  <Typography>
                    <strong>Size:</strong>{" "}
                    {(file.size / 1024).toFixed(2)} KB
                  </Typography>

                  <Box
                    sx={{
                      mt: 3,
                      display: "flex",
                      gap: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<RemoveRedEyeIcon />}
                      onClick={() => setPreviewOpen(true)}
                    >
                      Preview
                    </Button>

                    <Button
                      variant="contained"
                      color="error"
                      startIcon={<DeleteIcon />}
                      onClick={removeFile}
                    >
                      Remove
                    </Button>
                  </Box>
                </>
              ) : (
                <Typography
                  color="text.secondary"
                  mt={2}
                >
                  No PDF selected.
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Forwarding Letter Preview</DialogTitle>

        <DialogContent
          dividers
          sx={{
            height: "80vh",
          }}
        >
          {previewUrl ? (
            <iframe
              src={previewUrl}
              title="PDF Preview"
              width="100%"
              height="100%"
              style={{
                border: "none",
              }}
            />
          ) : (
            <Typography>No Preview Available</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setPreviewOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}